import { cn } from '@/lib/utils';

/** Shared floating panel shell — help icons, charts, sidebar labels. */
export const appTooltipPanelClassName = cn(
  'rounded-[10px] border border-border/60 bg-popover px-3 py-2',
  'text-xs text-popover-foreground',
  'shadow-[0_8px_24px_hsl(var(--foreground)/0.08)]'
);

/** Default Radix TooltipContent styling. */
export const appTooltipContentClassName = cn(
  appTooltipPanelClassName,
  'text-balance leading-snug'
);

/** Wider copy for (i) help on KPI and chart widgets. */
export const appTooltipHelpContentClassName = cn(
  appTooltipContentClassName,
  'max-w-[15.5rem] py-2.5 text-left leading-relaxed font-normal'
);

/** Chart hover cells — compact width, arrow hidden via `hideArrow` on TooltipContent. */
export const appTooltipChartContentClassName = cn(
  appTooltipContentClassName,
  'max-w-xs space-y-1'
);
